import { $generateHtmlFromNodes } from "@lexical/html";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";
import { $getRoot, $isElementNode, $isTextNode, LexicalNode } from "lexical";

const HtmlGeneratorPlugin = ({ onChange }) => {
  const [editor] = useLexicalComposerContext();

   useEffect(() => {
    return editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        // ✅ Get JSON (for persistence)
        const json = editorState.toJSON();

        // ✅ Also get HTML (for preview/rendering if needed)
        const html = $generateHtmlFromNodes(editor);

        // Send both back to parent
        onChange({
          json: JSON.stringify(json),
          html,
        });
      });
    });
  }, [editor, onChange]);
  return null;

  // editor.registerUpdateListener(() =>
  //   editor.update(() => {
  //     // const editorState = editor.getEditorState();
  //     // const json = editorState.toJSON();
  //     onChange(($generateHtmlFromNodes(editor, null)))
  //     // if(formFields && formFields.setValues) {
  //     //     formFields.setValues({textHTML:JSON.stringify($generateHtmlFromNodes(editor, null))})
  //     // }
  //   })
  // );

  function getHtmlTagForLexicalNode(node) {
    const type = node.__type;
    switch (type) {
      case "root":
        return null;
      case "paragraph":
        return "p";
      case "heading":
        return `h${node.getTag ? node.getTag().replace("h", "") : "1"}`
      case "list":
        return node.getListType() === "bullet" ? "ul" : "ol"
      case "listitem":
        return "li";
      case "table":
        return "table";
      case "tablerow":
        return "tr";
      case "tablecell":
        return node.__headerState === 1 ? "th" : "td";
      default:
        return null;
    }
  }

  function extractContentWithPlaceholders(node) {
    if (
      typeof node.__mention === "object" &&
      node.__mention !== null &&
      typeof node.__mention.key === "string"
    ) {
      return `{${node.__mention.key}}`;
    }

    if ($isTextNode(node)) {
      let text = node.getTextContent();
      if (node.isBold && node.isBold()) text = `<strong>${text}</strong>`;
      if (node.isItalic && node.isItalic()) text = `<em>${text}</em>`;
      if (node.isUnderline && node.isUnderline()) text = `<u>${text}</u>`;
      return text;
    }

    if ($isElementNode(node)) {
      const tag = getHtmlTagForLexicalNode(node);
      const inner = node
        .getChildren()
        .map(extractContentWithPlaceholders)
        .join("");
        
      if (!tag) return inner;

      let attrs = "";
      if (tag === "td" || tag === "th") {
        if (typeof node.__colSpan === "number" && node.__colSpan > 1) {
          attrs += ` colspan="${node.__colSpan}"`;
        }
        if (typeof node.__rowSpan === "number" && node.__rowSpan > 1) {
          attrs += ` rowspan="${node.__rowSpan}"`;
        }
      }
      return `<${tag}${attrs}>${inner}</${tag}>`;
    }

    return "";
  }
};

export default HtmlGeneratorPlugin;
